module.exports = __webpack_public_path__ + "img/player_run_001.d1442e65.png";